import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const fmt = (v) =>
  v == null || v === "" ? "—" : Number(v).toLocaleString("en-IN", { maximumFractionDigits: 3 });

/**
 * Nov 4 2026, user's ask: "on the production posting page right now only
 * decision given qty show but remaining qty is not reflect with the status of
 * QC decision pending ... make all decisions highlighted so that production
 * user can read it easily - Lot no, quality notification no, Confirmed Qty,
 * Scrap Qty, Rework Qty (if decision given), Pending Qty - bold text."
 */
export const QualityDecisionSummary = ({ row, unit }) => {
  const quality = row?.quality;
  if (!quality?.note_id) return null;
  const pending = Number(quality.to_decide_quantity || 0);
  const rework = Number(quality.rework_quantity || 0);
  const hold = Number(quality.hold_quantity || 0);
  return (
    <div className="rounded-sm border-2 border-[#026AA2] bg-[#EFF8FF] px-3 py-2" data-testid="quality-decision-summary">
      <div className="text-[12px] font-bold text-[#026AA2] uppercase tracking-wide">
        Lot {row.production_lot_id} · Quality Note {quality.note_id}
      </div>
      <div className="mt-1.5 grid grid-cols-2 sm:grid-cols-4 gap-2 text-[13px]">
        <div>
          <div className="text-[11px] text-[#475467]">Confirmed Qty</div>
          <div className="font-bold tabular-nums text-[#027A48]" data-testid="quality-confirmed-qty">
            {fmt(quality.decided_confirmed_quantity || 0)} {unit}
          </div>
        </div>
        <div>
          <div className="text-[11px] text-[#475467]">Scrap Qty</div>
          <div className="font-bold tabular-nums text-[#B54708]" data-testid="quality-scrap-qty">
            {fmt(quality.decided_scrap_quantity || 0)} {unit}
          </div>
        </div>
        {(rework > 0 || hold > 0) && (
          <div>
            <div className="text-[11px] text-[#475467]">{rework > 0 ? "Rework Qty" : "Hold Qty"}</div>
            <div className="font-bold tabular-nums text-[#B42318]" data-testid="quality-rework-qty">
              {fmt(rework > 0 ? rework : hold)} {unit}
            </div>
          </div>
        )}
        <div>
          <div className="text-[11px] text-[#475467]">Pending Qty</div>
          <div className="font-bold tabular-nums text-[#B54708]" data-testid="quality-pending-qty">
            {fmt(pending)} {unit}
          </div>
        </div>
      </div>
      <div className="mt-1.5 text-[12px] font-bold text-[#026AA2]" data-testid="quality-decision-status">
        {pending > 0
          ? `${fmt(pending)} ${unit} still with quality - decision pending, you cannot post it yet`
          : "Quality has decided every piece - post the figures above"}
      </div>
      {quality.decision?.remark ? (
        <div className="mt-1 text-[12px] text-[#475467] italic" data-testid="quality-decision-remark">
          "{quality.decision.remark}" — {quality.decision.decided_by}
        </div>
      ) : null}
    </div>
  );
};

/** The same figures, reachable from the row even when Confirm is disabled. */
export const QualityDecisionDialog = ({ row, unit, onClose }) => (
  <Dialog open={!!row} onOpenChange={(open) => !open && onClose()}>
    <DialogContent className="max-w-xl" data-testid="quality-decision-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading">Quality decision on this step</DialogTitle>
      </DialogHeader>
      {row && <QualityDecisionSummary row={row} unit={unit} />}
    </DialogContent>
  </Dialog>
);
